// extracted by mini-css-extract-plugin
export default {"menuTab":"brand-global-nav-menus-MenuTab__menuTab--CMVUJ","hovering":"brand-global-nav-menus-MenuTab__hovering--RFGIQ"};